
  import { Vue, Component, Prop } from "vue-property-decorator";
  import MultiselectAvatarTag from "@/components/autocompleteMultiselects/MultiselectAvatarTagNew.vue";
  import MultiselectAvatar from "@/components/autocompleteMultiselects/MultiselectAvatar.vue";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import S3Image from "@/components/common/s3-image.vue";
  import getFullName from "@/helpers/getFullName";
  import getInitials from "@/helpers/getInitials";
  import TableAvatar from "@/components/table/TableAvatar.vue";
  import BookmarkIcon from "@/components/common/BookmarkIcon.vue";

  @Component({
    components: {
      MultiselectAvatarTag,
      MultiselectAvatar,
      DropdownFilter,
      S3Image,
      TableAvatar,
      BookmarkIcon,
    },
  })
  export default class EmployeeMultiselect extends Vue {
    getFullName = getFullName;
    getInitials = getInitials;

     @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
      @Prop({ type: Number, default: undefined }) readonly max?: number;
      @Prop({ type: String }) readonly parentStyles: String;
    @Prop({ type: String, default: undefined, required: false }) readonly cref: string;
    @Prop({ type: Map, default: () => new Map() }) readonly bookmarkedUsers!: Map<string, any>;
    
    mounted() {
      // Component mounted
    }
        
    onSetRef(ref){
        this.$emit('setRef', ref)
    }

  }

